// 生产环境中注释掉以下语句
// import '../mock/index.js'

import './assets/styles/index.scss'
// import './assets/styles/themes/base.less'
import './assets/styles/themes/antd/index.less'
// import 'babel-polyfill'

import Vue from "vue"
import router from './router'
import store from './store'
import request from './util/request'
import utils from './util'
import ui from './util/ui'
import auth from './util/auth'
import iView from 'iview'
// import ViewUI from 'view-design'

import App from './App'
import i18n from './i18n'
// import iviewArea from 'iview-area'
import viserVue from 'viser-vue'
import * as vClickOutside from 'v-click-outside-x'

// import VModal from 'vue-js-modal'

import './components'

// import './plugins'
// import './filters'

// import { gcj2wgs } from './util/map/proj'

Vue.prototype.$request = request
Vue.prototype.$utils = utils
Vue.prototype.$ui = ui
Vue.prototype.$auth = auth
Vue.prototype.$a = auth.hasAuthority

Vue.use(iView)
Vue.use(router)
Vue.use(viserVue)
Vue.use(vClickOutside)
// Vue.use(VModal,{dynamic: true, injectModalsContainer: true })


window.addEventListener('storage',function (e) {
  if(e.key == 'server'){
    location.reload()
  }
})

new Vue({
  request,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
